import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../../toast-service';
import {CrystalclearCustomerBackUrl} from "../../config/crystalclear-customer-back-url";
import {AccountTrader} from "../../../model/customer/account-trader";
import {BatchUpdateRequest} from "../../../model/api/batch-update-request";
import {Observable} from "rxjs";
import {ApiValidation} from "../../../model/api/api-validation";
import {CommonCrudService} from "../../common/common-crud.service";

@Injectable({
  providedIn: 'root'
})
export class CustomerAccountTraderService extends CommonCrudService<AccountTrader> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearCustomerBackUrl.GET_CUSTOMER_ACCOUNT_TRADER_LIST,
      CrystalclearCustomerBackUrl.SAVE_CUSTOMER_ACCOUNT_TRADER,
      CrystalclearCustomerBackUrl.DELETE_CUSTOMER_ACCOUNT_TRADER);
  }

  public saveBatch(request: BatchUpdateRequest<AccountTrader>): Observable<ApiValidation<any>> {
    return this.post(CrystalclearCustomerBackUrl.SAVE_BATCH_CUSTOMER_ACCOUNT_TRADER, request);
  }

  public cloneBatch(request: BatchUpdateRequest<AccountTrader>): Observable<ApiValidation<any>> {
    return this.post(CrystalclearCustomerBackUrl.CLONE_BATCH_CUSTOMER_ACCOUNT_TRADER, request);
  }

}
